<template>
    <div style="display: flex; flex-direction: column; justify-content: center">
        <div class="card-title">{{ name }}</div>
        <div style="display: flex; flex-direction: row; justify-content: center">
            <div class="card yellow" style="margin-right: 20px" @click="yellowCardClicked"></div>
            <div class="card red" @click="redCardClicked"></div>
        </div>
    </div>
</template>
    
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { eventBus } from '../main'

export default {
    props: ['name'],
    methods: {
        yellowCardClicked() {
            this.$emit('yellowCardClicked');
        },
        redCardClicked() {
            this.$emit('redCardClicked');
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/Cards.vue